// extracted by mini-css-extract-plugin
export default {"icon":"SortingIcon_icon__n6YN3","icon_visible":"SortingIcon_icon_visible__gt0Cx","icon_invisible":"SortingIcon_icon_invisible__rx+u2","icon_down":"SortingIcon_icon_down__Rk-A4"};